import React, { useState } from "react";
import "../Styles/signUp.css";
import logo from "../asset/Image/logo.png";
import { CircularProgress } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logoBlack from "../asset/Image/logo1.png";
import { BiArrowBack } from "react-icons/bi";
import api from "../util/axios";

const VerifyEmail = () => {
    const { state } = useLocation();
    const email = state?.email || "";
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [sign, setSign] = useState({
        otp: "",
    });

    const handleChange = ({ target: { name, value } }: any) => {
        setSign({ ...sign, [name]: value });
    };

    const handleSubmit = (e: any) => {
        if (!email) {
            toast.error("Some error occured, please try again!")
            setTimeout(() => {
                navigate(-1)
            }, 3000);
        }
        setLoading(true);
        e.preventDefault();

        api
            .post(
                "/auth/email-verification/business",
                {
                    email: email,
                    otp: sign.otp,
                }
            )
            .then((res) => {
                toast.success("Verification successful! You can now login.");
                console.log("res,", res.data)
                setLoading(false);
                setTimeout(() => {
                    navigate("/");
                }, 3000)
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message);
                setLoading(false);
            });
    };

    return (
        <div className="auth">
            <ToastContainer />
            <div className="left">
                <div>
                    <img src={logo} alt="" />

                    <div className="leftCon1">
                        <h2>Verify Account</h2>
                        <p>Verify your account with the otp sent to your email</p>
                        <form onSubmit={handleSubmit}>
                            <div className="input1">
                                <label
                                    htmlFor="otp"
                                >
                                    Otp <span className="text-red-600">*</span>
                                </label>
                                <input
                                    type="text"
                                    maxLength={6}
                                    name="otp"
                                    required
                                    value={sign.otp || ""}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="flex w-full gap-2 mt-16">
                                <button onClick={(() => navigate(-1))} className="bg-white text-black flex gap-1 justify-center items-center"><span><BiArrowBack /></span>Back</button>
                                <button type="submit" className="bg-blue-600 text-white">
                                    {loading ? (
                                        <CircularProgress
                                            style={{ color: "#fff", width: "25px", height: "25px" }}
                                        />
                                    ) : (
                                        "Continue"
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div className="right">
                <div className="rightCon">
                    <h4>Oneflare Business Suite</h4>
                    <h2>
                        <h2>
                            You don't <span>Remember?</span>  Don’t worry we got you{" "}
                            <span>covered.</span>
                        </h2>
                    </h2>
                </div>

                <img src={logoBlack} alt="" className="logoBottom" />
            </div>
        </div>
    );
};

export default VerifyEmail;
